import { ListViewChildProps } from '@app/core/list-view/ListView';
import { SavedReportsTable } from '../components/SavedReportsTable';
import { SavedReportListItem } from '../types';

/**
 * Broadcast Evidence table: includes the station column next to the name.
 */
export function SavedReportsBroadcastEvidenceTable(props: ListViewChildProps<SavedReportListItem>) {
  return <SavedReportsTable {...props} showStation />;
}
